export default function debounce<TParams>(
  fn: (...params: TParams[]) => void,
  time: number
) {
  let timerId: ReturnType<typeof setTimeout> | undefined = undefined;

  return [function (...args: TParams[]) {
    if (timerId) {
      clearTimeout(timerId);
    }

    timerId = setTimeout(() => fn(...args), time);
  }, function () {
    if (timerId) {
      clearTimeout(timerId);
    }
  }]
}